import { render, staticRenderFns } from "./FinalizarCompra.vue?vue&type=template&id=5c351e3a&scoped=true&"
import script from "./FinalizarCompra.vue?vue&type=script&lang=js&"
export * from "./FinalizarCompra.vue?vue&type=script&lang=js&"
import style0 from "./FinalizarCompra.vue?vue&type=style&index=0&id=5c351e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c351e3a",
  null
  
)

export default component.exports